import { render, staticRenderFns } from "./DetailQuotation.vue?vue&type=template&id=a8961a54&scoped=true&"
import script from "./DetailQuotation.vue?vue&type=script&lang=ts&"
export * from "./DetailQuotation.vue?vue&type=script&lang=ts&"
import style0 from "./DetailQuotation.vue?vue&type=style&index=0&id=a8961a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8961a54",
  null
  
)

export default component.exports